import { render, staticRenderFns } from "./statistics-item.vue?vue&type=template&id=c94f1744&"
import script from "./statistics-item.vue?vue&type=script&lang=js&"
export * from "./statistics-item.vue?vue&type=script&lang=js&"
import style0 from "./statistics-item.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports